module.exports = __webpack_public_path__ + "img/fr1.11c40098.png";